export const INPUT_PARAM_MENU_CONFIG = [
  { id: 'save', name: 'Save' },
  { id: 'save-as', name: 'Save As' },
  { id: 'delete', name: 'Delete' },
];

export const INPUT_PARAM_MENU_CONFIG_FOR_DEFAULT = [
  { id: 'save-as', name: 'Save As' },
];
